import { gql } from '@apollo/client';

const GET_BUYER_ACCOUNT = gql`
    mutation getBuyerAccount($accessToken: String! $groupId: String) {
        getBuyerAccount(accessToken: $accessToken groupId: $groupId) {
            status
            data {
                email
                firstName
                lastName
                magentoToken,
                groupId
            }
        }
    }
`;
export default GET_BUYER_ACCOUNT;
